import { useIntl } from 'react-intl'
import Typography from '../../../../Typography/Typography'

import './MemberBenefits.scss'

const MemberBenefits = ({ className }) => {
    const intl = useIntl()

    const benefits = [
        {
            name: 'sleva',
            description: intl.formatMessage({ id: 'forms.register.clubMemberBenefits.benefitDiscount' }),
        },
        {
            name: 'odmeny',
            description: intl.formatMessage({ id: 'forms.register.clubMemberBenefits.benefitRewards' }),
        },
        {
            name: 'body',
            description: intl.formatMessage({ id: 'forms.register.clubMemberBenefits.benefitPoints' }),
        },
    ]

    return (
        <div className={`member-benefits d-flex flex-column text-center ${className}`}>
            <Typography variant={'h1'} className={'px-7'}>
                {intl.formatMessage({ id: 'forms.register.clubMemberBenefits.title' })}
            </Typography>
            <div className="member-benefits--options d-flex">
                {benefits.map(({ name, description }) => (
                    <div key={name} className="option d-flex flex-column">
                        <img src={`images/badges/${name}.svg`} alt={name} className="mx-auto" />
                        <Typography variant={'subtitle'}>{description}</Typography>
                    </div>
                ))}
            </div>
            <Typography variant={'p'} color={'whiteTransparent'}>
                {intl.formatMessage({ id: 'forms.register.clubMemberBenefits.feeText' })}
            </Typography>
        </div>
    )
}

export default MemberBenefits
